module.exports = __webpack_public_path__ + "static/media/memories_3.1108f7d7.jpg";